import {DecorationMethods} from './DecorationMethods';

const decorationOverrides = [
  // Matching by style ids
  {
    decorationMethods: [],
    materials: [],
    styleIds: [1072200, 1071900, 1166900, 1166500, 1523300, 1513200],
    enforceColor: 'White',
    restrictColorPalette: true,
    effect: null
  },
  {
    decorationMethods: [],
    materials: [],
    styleIds: [1145100, 1141400, 1141500],
    enforceColor: null,
    restrictColorPalette: true,
    effect: 'laser_engraved'
  },
  // Force laser engraved effect for Laser Engraved 28 oz. Elvin Stainless Steel Recycled Sports Water Bottle
  // as this product is made of steel, but also has plastic in the material description
  {
    decorationMethods: [],
    materials: [],
    styleIds: [1636500],
    enforceColor: 'Gray',
    restrictColorPalette: true,
    effect: 'laser_engraved'
  },
  // Force laser engraved leather patch products to use a black color
  {
    decorationMethods: [],
    materials: [],
    styleIds: [1099000, 1629200, 1081800, 1081600],
    enforceColor: 'Black',
    restrictColorPalette: true,
    effect: 'laser_engraved'
  },
  // Force laser engraved zinc keychain to use a grey color
  {
    decorationMethods: [],
    materials: [],
    styleIds: [1550400],
    enforceColor: 'Zinc Alloy',
    restrictColorPalette: true,
    effect: 'laser_engraved'
  },
  // Matching by combination of material and decoration method
  {
    decorationMethods: [DecorationMethods.DEBOSSED],
    materials: [
      'leather',
      'durahyde',
      'ultrahyde',
      'ultrabond',
      'faux suede',
      'faux leather',
      'vinyl',
      'cardboard'
    ],
    styleIds: [],
    enforceColor: null,
    restrictColorPalette: true,
    effect: 'debossed'
  },
  {
    decorationMethods: [DecorationMethods.EMBOSSED],
    materials: ['leather', 'foil'],
    styleIds: [],
    enforceColor: null,
    restrictColorPalette: true,
    effect: 'embossed'
  },
  {
    decorationMethods: [DecorationMethods.LASER_ENGRAVED],
    materials: ['plastic', 'cardboard', 'leather', 'silicone', 'fabric', 'pu'],
    styleIds: [],
    enforceColor: null,
    restrictColorPalette: true,
    effect: 'laser_engraved'
  },
  {
    decorationMethods: [DecorationMethods.LASER_ETCHED],
    materials: ['leather'],
    styleIds: [],
    enforceColor: null,
    restrictColorPalette: true,
    effect: 'laser_etched'
  },
  {
    decorationMethods: [DecorationMethods.LASER_ENGRAVED],
    materials: ['glass', 'crystal', 'acrylic'],
    styleIds: [],
    enforceColor: 'Ice Gray',
    restrictColorPalette: true,
    effect: null
  },
  {
    decorationMethods: [DecorationMethods.LASER_ENGRAVED],
    materials: ['terracotta'],
    styleIds: [],
    enforceColor: 'Brown',
    restrictColorPalette: true,
    effect: null
  },
  {
    decorationMethods: [DecorationMethods.LASER_ENGRAVED],
    materials: ['ceramic'],
    styleIds: [],
    enforceColor: 'Warm Ivory',
    restrictColorPalette: true,
    effect: null
  },
  // Matching by decoration methods only
  {
    decorationMethods: [DecorationMethods.DEBOSSED, DecorationMethods.EMBOSSED],
    materials: [],
    styleIds: [],
    enforceColor: null,
    restrictColorPalette: true,
    effect: 'color_matching'
  }
];

export default decorationOverrides;
